<script setup lang="ts">
import Button from '@/components/Button.vue';

import iconDiscovery from "@/components/icons/iconDiscovery.vue";
import iconSolution from "@/components/icons/iconSolution.vue";
import iconImplementation from "@/components/icons/iconImplementation.vue";
import iconSupportWaste from "@/components/icons/iconSupportWaste.vue";
import iconRefine from "@/components/icons/iconRefine.vue";
import ISolveIcon from "@/components/ISolveIcon.vue";



import { vwWithMax } from '@/utility/utility';


const emit = defineEmits<{
  (e: 'toggle'): void
}>()

const router = useRouter()

function redirect(path: string) {
  router.push(path)

  nextTick(() => {
    emit('toggle')
  })
}

const route = useRoute()

function serviceActive(service: string) {
  const keys = Object.keys(route.query)
  return keys.includes(service)
}

// This is important, we need to have this value set for each megaMenu as the initial popover load doesn't calculate the height correctly if this is not set
const defultWidth = computed(() => vwWithMax(80, 1300) + "px");
</script>

<template>
  <Section id="mega-about" class="io-mega-popover sec-popover-container popover-about mega-about" >
    <Section class="sec-mega-container" w="grid grid-cols-[0.8fr_1fr_1fr] g-1">

      <Column class="column-1 column mega-column-hero-title" w="flex flex-col g-1 items-start max-w-92%">
        
          <div class="gpt-1.5 sec-primary-title">
            <div>The 360<span class="deg">°</span> iSolvents Experience</div>
            <div class="line" />
          </div>
          <div class="sec-primary-content">
            <p>At iSolvents, we recognise that offering individual solutions is just one facet of our expertise. What truly sets us apart is our deep commitment to truly understanding your business and its distinct requirements and challenges. </p>

            <!-- <p>Our approach is designed to ensure precision, harmony, and growth for your business. From in-depth discovery to continuous enhancement, each phase is crucial in crafting a tailored solution that truly maximises with your unique process and requirements.</p> -->
          </div>
          <div class="sec-actions">
            <div class="action btn-learn">
              <Button btn="blue" class="gpy-0.5 gpx-1.25 fs--1 fw-600 flex items-center g-0.5" @click="redirect('/our-service')">
                Learn more
              </Button>
            </div>
          </div>
        

      </Column>
      <Column class="column-2 column col-link-cards" w="grid g-0.5">
        <div class="mega-column-title" >
          <div>Our 360-Degree Service</div>
        </div>
        <div class="sec-link-cards grid !g-0.25 solutions">

          <a class="sec-nav-card-link feature" @click="redirect('/our-service?discovery')">
            <div class="wrap">
              <div class="icon">

                <iconDiscovery class="c-icon icon-discovery" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Discovery Assessment</h3>
                <p class="linkSub">Tailoring solutions through in-depth insights.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?solutions')">
            <div class="wrap">
              <div class="icon">
                <iconSolution class="c-icon icon-solution" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Solution Development</h3>
                <p class="linkSub">Crafting solutions optimised for quality and efficiency.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?implementation')">
            <div class="wrap">
              <div class="icon">
                <iconImplementation class="c-icon icon-implementation" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Implementation</h3>
                <p class="linkSub">Ensuring seamless delivery from production to your doorstep.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?support')">
            <div class="wrap"> 
              <div class="icon">
                <iconSupportWaste class="c-icon icon-support-waste" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Support & Waste Management</h3>
                <p class="linkSub">Health and eco-friendly practices to keep you compliant.</p>
              </div>
            </div>
          </a>
          <a class="sec-nav-card-link feature" @click="redirect('/our-service?refine')">
            <div class="wrap"> 
              <div class="icon">
                <iconRefine class="c-icon icon-refine" />
              </div>
              <div class="productLinkContent">
                <h3 class="linkTitle">Continuous Refinement</h3>
                <p class="linkSub">We review and refine for improved efficiency and effectiveness.</p>
              </div>
            </div>
          </a>

        </div>
      </Column>
      <Column class="column-3 column col-link-cards" w="grid g-1">
        <div class="mega-column-title">
          <div>iSolvents</div>
        </div>
        <div class="sec-link-cards flex flex-col items-start">
          <!-- <NavLinkCard :active="route.name === 'our-service'" @click="redirect('/our-service')" title="360 Services"
            description="Committed to practices that honor and preserve the planet for future generations."
            slug="our-service">
            <template #icon>
              <img class="w-28px" src="/molecule.png" alt="">
            </template>  
          </NavLinkCard>
          <NavLinkCard :active="route.name === 'about-us'" @click="redirect('/about-us')" title="About us"
            description="iSolvents, where operational inefficiencies are a thing of the past, and business growth is just the beginning."
            slug="about-us" >
            <template #icon>
              <img class="w-28px" src="/molecule.png" alt="">
            </template>
            </NavLinkCard> -->

            <a class="sec-nav-card-link simple services" :class="{'active': route.name === 'our-service'}" @click="redirect('/our-service')">
              <div class="wrap"> 
                <div class="icon">
                  
                <svg width="17" height="17"><path fill="#87BBFD" class="hover-fillLight" d="M.945 1.998h3.632C6.744 1.998 8.5 3.005 8.5 4.83v11.583c-.512 0-1.015-.337-1.33-.59-1.03-.828-3.057-.828-5.222-.828H.945A.944.944 0 0 1 0 14.052V2.944C0 2.422.423 2 .945 2z"></path><path fill="#6772E5" class="hover-fillDark" d="M16.055 1.998h-3.632C10.257 1.998 8.5 3.005 8.5 4.83v11.583c.512 0 1.015-.337 1.33-.59 1.03-.828 3.057-.828 5.222-.828h1.003A.944.944 0 0 0 17 14.05V2.945A.944.944 0 0 0 16.055 2z"></path></svg>
                </div>
                <div class="productLinkContent">
                  <h3 class="linkTitle">360 Services</h3>
                  <p class="linkSub">Discover our commitment to excellence through our comprehensive 360 degree service offering.</p>
                </div>
              </div>
            </a>

            <a class="sec-nav-card-link simple about-us" :class="{'active': route.name === 'about-us'}" @click="redirect('/about-us')">
              <div class="wrap"> 
                <div class="icon flex items-start">
                  <ISolveIcon />
                </div>
                <div class="productLinkContent">
                  <h3 class="linkTitle">About us</h3>
                  <p class="linkSub">From humble beginnings, discover how iSolvents has grown into a leading provider of innovative solutions.</p>
                </div>
              </div>
            </a>
        </div>
      </Column>
    </Section>
  </Section>

</template>

<style lang="scss" scoped>



#mega-about {
  width: v-bind(defultWidth);

  .sec-primary-title {
    > div {
      font-family: var(--quicksand);
    }
  }
  
  .btn-learn {

    > button {
      color: white !important;
    }
    .btn-learn {
      color: white !important;
    }
  }
}

.menu-circle-icon {
 .outer {
  background: red;
  .inner {
    background: blue;
    .icon {
      background: green;
    }
  }
 }
}

.sec-mega-container {
  
  // .bg-texture{
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  // }
}

.column-2 {
  .sec-link-cards {
    .sec-link-cards {
      &:hover {
        .sec-title {
          .title {
            
          }
        }
      }
    }
  }
}

.sec-link-cards {
  &.solutions {


    .sec-nav-card-link {
      &.feature {
        .c-icon {
  
          width: 24px !important;
          
        }
      }
    }


  }
}


</style>